// extracted by mini-css-extract-plugin
export var oWhoWeAre = "whoWeAre-module--o-who-we-are--1QTEy";
export var lContent__inner = "whoWeAre-module--l-content__inner--1ZsBO";
export var oWhoWeAre__balloon = "whoWeAre-module--o-who-we-are__balloon--3Z5we";
export var designEngineer = "whoWeAre-module--design-engineer--3KAaS";
export var specialist = "whoWeAre-module--specialist--24TNN";
export var history = "whoWeAre-module--history--16Wfp";
export var oWhoWeAre__decorationSpecialist = "whoWeAre-module--o-who-we-are__decoration--specialist--39PS4";
export var oWhoWeAre__decorationUiux = "whoWeAre-module--o-who-we-are__decoration--uiux--2szPh";
export var visible = "whoWeAre-module--visible--2aH16";
export var subcopyBefore = "whoWeAre-module--subcopy-before--1OuyL";
export var subcopyAfter = "whoWeAre-module--subcopy-after--1EXF2";
export var standby = "whoWeAre-module--standby--29z_E";